import type {
  ProtectedUser,
  ProtectedUsersResponse,
  Suspect,
  SuspectDto,
  SuspectsResponse,
  UpdateSuspectBody,
  UpdateSuspectResponse,
} from '../../shared/types/index.js';
import { attachAppNames, buildAppNameIndex } from '../domain/appNames.js';
import { request } from './client.js';

/** Suspects keyed by id, with app bundles resolved to `{ bundle, name }`. */
export async function fetchSuspects(backfillWaypoints = false): Promise<Record<string, Suspect>> {
  const { suspects, apps } = await request<SuspectsResponse>('/suspects', {
    query: { backfillWaypoints: backfillWaypoints || undefined },
  });
  const names = buildAppNameIndex(apps);

  const byId: Record<string, Suspect> = {};
  suspects.forEach(suspect => {
    byId[suspect.id] = { ...suspect, apps: attachAppNames(suspect.apps, names) };
  });
  return byId;
}

export async function updateSuspect(id: string, body: UpdateSuspectBody): Promise<SuspectDto> {
  const { suspect } = await request<UpdateSuspectResponse>(`/suspects/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body,
  });
  return suspect;
}

export async function fetchProtectedUsers(): Promise<Array<ProtectedUser>> {
  const { users } = await request<ProtectedUsersResponse>('/protected-users');
  return users;
}
